
import { createContext, useContext, useState, useEffect } from 'react';

const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [isB2BMode, setIsB2BMode] = useState(false);
  const [isToggleSidebar, setIsToggleSidebar] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [orderid, setorderId] = useState(null);  
  const [profile_flag, setProfile_flag] = useState();
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [selectedCft, setSelectedCft] = useState(6);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setIsDarkMode(true);
      document.documentElement.classList.add('dark');
    }

    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsToggleSidebar(false);
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  // Persist B2B mode to localStorage
  useEffect(() => {
    localStorage.setItem("isB2BMode", isB2BMode ? "1" : "0");
  }, [isB2BMode]);

  // Load B2B mode from localStorage on initial render
  useEffect(() => {
    const savedB2BMode = localStorage.getItem("isB2BMode") === "1";
    setIsB2BMode(savedB2BMode);

    // Also check URL to determine B2B mode on initial load
    const pathname = window.location.pathname;
    const isB2BPath = pathname.startsWith('/b2b');
    if (isB2BPath) {
      setIsB2BMode(true);
    }
  }, []);

  const toggleB2BMode = (value) => {
    setIsB2BMode(value);
  };

  return (
    <MyContext.Provider value={{
      isToggleSidebar,
      setIsToggleSidebar,
      profile_flag,
      setProfile_flag,
      isDarkMode,
      toggleTheme,
      orderid,
      setorderId,
      setIsDarkMode,
      isB2BMode,
      setIsB2BMode, 
      toggleB2BMode,
      isPageLoading,
      setIsPageLoading,
      setSelectedCft,
      selectedCft
    }}>
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => useContext(MyContext);